module.exports = __webpack_public_path__ + "static/support-e2237d2d8e554f4b542d650bd5c114da.png";